(()=>{
  function toggleDocsLoading(isLoading) {
    document.querySelector('.js_docs-search-loader')?.classList.toggle('hidden', !isLoading);
    document.querySelector('.media-grid.material')?.classList.toggle('loading', isLoading);
  }

  class ProductDocsSearch extends PredictiveSearch{
    static get observedAttributes() {
      return ['data-filter-active'];
    }
    constructor() {
      super();
      this.setupEventListeners();
      // Override the original Shopify behavior:
      // keep cached results isolated to this instance only.
      this.allPredictiveSearchInstances = [this];
    }

    getSearchResults(searchTerm) {
      const searchQuery = this.getSearchQuery(searchTerm);
      const queryKey = searchQuery.replace(/ /g, '-').toLowerCase();

      super.setLiveRegionLoadingState();

      if (this.cachedResults[queryKey]) {
        super.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }
      // Request markup defined in predictive-search-product-selector.liquid to render results in the dropdown - static section
      fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchQuery)}&resources[type]=product&section_id=predictive-search-product-selector`, {
        signal: this.abortController.signal,
      })
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            super.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search-product-selector').innerHTML;
          // Cache results on this instance only
          this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          });
          super.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          if (error?.code === 20) {
            // Code 20 means the call was aborted
            return;
          }
          super.close();
          throw error;
        });
    }

    attributeChangedCallback(name, oldValue, newValue) {
      // If a family filter changes, re-run the search with the current term.
      if (name === 'data-filter-active' && oldValue !== newValue && this.searchTerm) {
        this.getSearchResults(this.searchTerm);
      }
    }

    getSearchQuery(userInput) {
      if (!userInput) return '';
      // If family filter is active build the query to filter by TAG
      // With predictive search we have limited option to filter
      const filter = this.getAttribute('data-filter-active');
      if (filter && filter !== 'all' && filter !== '') {
        return `tag:${filter} AND ${userInput}`;
      }
      return userInput;
    }

    onFormSubmit(event) {
      // Submit form will cause navigation to PDP, so we prevent
      event.preventDefault();
    }

  }
  if (!customElements.get('product-docs-search')) {
    customElements.define('product-docs-search', ProductDocsSearch);
  }
  class ProductDocsResultItem extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.productHandle = this.getAttribute('data-product-handle');
      this.productTitle = this.getAttribute('data-product-title');
      this.bindedClickHandler = this.handleResultClick.bind(this);

      this.attachListeners();
    }

    attachListeners(){
      this.addEventListener('click', this.bindedClickHandler)
    }
    async handleResultClick(){
      this.closest('product-docs-search')?.close();
      toggleDocsLoading(true);
      try{
        // Fetch markup defined in product-technical-sheet-results.liquid - static section
        const response = await fetch(`${Shopify.routes.root}products/${this.productHandle}?section_id=product-docs-results`)
        if (!response.ok) {
          console.error('Response not ok', response.status);
        }
        const text = await response.text();
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')

        this.renderResults(resultsMarkup);
        toggleDocsLoading(false);
        // Update the search input value with the selected product title
        const searchInput = document.querySelector('product-docs-search input[type="search"]');
        if(searchInput) searchInput.value = this.productTitle;
      }
      catch(error){
        console.error(error);
      }
    }
    renderResults(resultsMarkup){
      // Inject new markup in the following DOM Elements
      const selectors = [
        'FilterFileTypes',
        'VideosResults',
        'TechnicalSheetResults',
        'ManualsResults',
        'PaginateResults',
      ]

      selectors.forEach(selector => {
        const newHtml = resultsMarkup.querySelector(`#${selector}`);
        const oldHtml = window.document.getElementById(selector);
        oldHtml.innerHTML = newHtml?.innerHTML || '';
      })

      const emptyDocs = document.getElementById('EmptyDocs');
      const fetchedEmpty = resultsMarkup.getElementById('EmptyDocs');
      const isEmpty = !fetchedEmpty?.classList.contains('hidden');

      if (isEmpty) {
        const source = fetchedEmpty?.getAttribute('data-source');
        if (source) emptyDocs.querySelector('strong').textContent = source;
      }
      emptyDocs.classList.toggle('hidden', !isEmpty);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.bindedClickHandler);
    }
  }
  if (!customElements.get('product-docs-result-item')) {
    customElements.define('product-docs-result-item', ProductDocsResultItem);
  }

  class DocsFilters extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      // Basic behavior on filters (family & file type) selection
      this.filters = this.querySelectorAll('button.js_filter');
      this.selected = this.querySelector('button.js_filter.active');
      this.bindedClickHandler = this.handleFilterSelection.bind(this);

      this.attachListeners();
    }

    attachListeners() {
      this.filters.forEach(button => {
        button.addEventListener('click', this.bindedClickHandler);
      })
    }
    handleFilterSelection(event){
      const clicked = event.currentTarget;
      if (clicked === this.selected) return;
      if (this.selected) {
        this.selected.classList.remove('active');
      }
      clicked.classList.add('active');
      this.selected = clicked;

      this.onFilterSelected(clicked);
    }
    disconnectedCallback() {
      if (!this.filters) return;
      this.filters.forEach(button => {
        button.removeEventListener('click', this.bindedClickHandler);
      })
    }
    // Subclasses have to override this
    onFilterSelected(clickedButton) {}
  }
  class DocsFileTypeFilters extends DocsFilters {
    connectedCallback() {
      super.connectedCallback();
      this.resultsWrapper = window.document.querySelector('[data-file-type-active]');
      this.resultsWrapper.setAttribute('data-file-type-active', 'all');
    }

    onFilterSelected(clickedButton) {
      // We use CSS to show/hide correct files type wrappers
      const type = clickedButton.getAttribute('data-file-type-filter-value');
      this.resultsWrapper.setAttribute('data-file-type-active', type);
    }
  }
  if (!customElements.get('docs-file-type-filters')) {
    customElements.define('docs-file-type-filters', DocsFileTypeFilters);
  }

  class FamilyFilters extends DocsFilters {
    connectedCallback() {
      super.connectedCallback();
      this.searchInstance = document.querySelector('product-docs-search');
      this.selectedCollection = null;
      this.paginationWrapper = document.getElementById('PaginateResults');

      this.bindedHandlePaginationClick = this.handlePaginationClick.bind(this);
      this.paginationWrapper.addEventListener('click',this.bindedHandlePaginationClick)

      const defaultButton = this.querySelector('button.js_filter.active');
      if (defaultButton?.getAttribute('data-collection-url')) {
        this.searchByCollection(defaultButton.getAttribute('data-collection-url'));
      }
    }

    onFilterSelected(clickedButton) {
      if (!this.searchInstance) return;
      const collectionUrl = clickedButton.getAttribute('data-collection-url');
      const filterValue = clickedButton.getAttribute('data-filter-value');
      const searchInput = document.querySelector('product-docs-search input[type="search"]');
      if (collectionUrl){
        this.searchInstance.searchTerm = "";
        if(searchInput) searchInput.value = "";
        this.searchByCollection(collectionUrl)
      }
      else {
        searchInput && searchInput.focus();
      }
      this.searchInstance.setAttribute('data-filter-active', filterValue);
    }
    async searchByCollection(collectionUrl) {
      if (this.selectedCollection === collectionUrl) return;
      this.selectedCollection = collectionUrl;

      toggleDocsLoading(true);

      const selectors = ['VideosResults', 'TechnicalSheetResults', 'ManualsResults'];
      const accumulated = new Map(selectors.map(s => [s, null]));
      let accumulatedFilterFileTypes = null;
      let page = 1;
      let hasNextPage = true;
      let lastDoc = null;

      const seen = new Map(
        selectors.map(s => [s, new Set()])
      );

      while (hasNextPage) {
        const fetchUrl = `${collectionUrl}?page=${page}&section_id=collection-docs-results`;
        try {
          const response = await fetch(fetchUrl);
          if (!response.ok) break;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          lastDoc = doc;

          selectors.forEach(s => {
            const el = doc.getElementById(s);
            if (!el) return;
            const entry = accumulated.get(s);
            // We don't have any results yet
            if (!entry) {
              accumulated.set(s, el.cloneNode(true));
            }
            // Update only the items
            else {
              const items = el.querySelectorAll('.media-grid__item');
              const list = entry.querySelector('.media-grid__list');
              const seenSet = seen.get(s);

              if (!list || !items.length) return;

              items.forEach(item => {

                const duplicateId = item.dataset.duplicateId;

                if (!duplicateId) {
                  list.appendChild(item.cloneNode(true));
                  return;
                }

                if (seenSet.has(duplicateId)) return;

                seenSet.add(duplicateId);
                list.appendChild(item.cloneNode(true));

              });
            }
          });

          const filterEl = doc.getElementById('FilterFileTypes');
          if (filterEl) {
            if (!accumulatedFilterFileTypes) {
              accumulatedFilterFileTypes = filterEl.cloneNode(true);
            } else {
              // For each type check if the button is present in the fetched response and missing in accumulate results
              ['video', 'tech_sheet', 'manual'].forEach(type => {
                const newBtn = filterEl.querySelector(`button[data-file-type-filter-value="${type}"]`);
                const existingBtn = accumulatedFilterFileTypes.querySelector(`button[data-file-type-filter-value="${type}"]`);
                if (newBtn && !existingBtn) {
                  // Find the correct li in the accumulate and append button
                  const targetLi = accumulatedFilterFileTypes.querySelector(`li[id$="-${type}"]`);
                  if (targetLi) targetLi.appendChild(newBtn.cloneNode(true));
                }
              });
            }
          }

          const paginateEl = doc.getElementById('PaginateResults');
          hasNextPage = !!paginateEl?.querySelector(`a[href*="page=${page + 1}"]`);
          page++;
        } catch (error) {
          console.error(error);
          break;
        }
      }

      toggleDocsLoading(false);

      const filterWrapper = document.getElementById('FilterFileTypes');
      if (filterWrapper && accumulatedFilterFileTypes) {
        filterWrapper.innerHTML = accumulatedFilterFileTypes.innerHTML;
      }

      accumulated.forEach((newHtml, selector) => {
        const oldWrapper = window.document.getElementById(selector);
        if (!oldWrapper) return;
        oldWrapper.innerHTML = newHtml?.innerHTML || '';
      });

      const isEmpty = [...accumulated.values()].every(clone => {
        if (clone === null) return true;
        return clone.querySelectorAll('.media-grid__item').length === 0;
      });
      const emptyDocs = document.getElementById('EmptyDocs');

      if (isEmpty && lastDoc) {
        const source = lastDoc.getElementById('EmptyDocs')?.getAttribute('data-source');
        if (source) emptyDocs.querySelector('strong').textContent = source;
      }
      emptyDocs.classList.toggle('hidden', !isEmpty);


    }

    handlePaginationClick(event){
      const target = event.target.closest('a');
      if (target && this.paginationWrapper.contains(target)) {
        event.preventDefault();
        event.stopPropagation();
        const href = target.getAttribute('href');
        const url = new URL(href, window.location.origin);
        const page = url.searchParams.get('page');

        this.searchByCollection(url.pathname,page);
      }
    }
  }
  if (!customElements.get('family-filters')) {
    customElements.define('family-filters', FamilyFilters);
  }

})()

